import React, { useCallback } from "react";

import { CheckboxInput } from "../CheckboxInput";

const NoteStep = ({ step, readOnly, onStepUpdate, inCorrectiveAction }) => {

    const toggleUseNoteAsDescription = useCallback(() => {
        if (step.useNoteAsDescription === true) {
            onStepUpdate({ ...step, useNoteAsDescription: false });
        } else {
            onStepUpdate({ ...step, useNoteAsDescription: true });
        }
    }, [step]);

    return (step.checklistTaskOptionType.token === "note") && inCorrectiveAction === false && (
        <div>
            <div className="form-group">
                <label>&nbsp;</label>
                <CheckboxInput
                    input={{ checked: step.useNoteAsDescription === true, onChange: toggleUseNoteAsDescription, disabled: readOnly }}
                    label="Use Note To Describe Checklist"
                    className="inline"
                    meta={{}}
                />            
            </div>
        </div>
    );

};

export default NoteStep;
